<template>
  <div class="analyse" >
    <el-row class="mb20"  :gutter="20">
      <el-col :span="24">
        <el-card>
          <el-date-picker
            v-model="month"
            type="month"
            size="mini"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="pickerDataChangeUpload"
            placeholder="选择月">
          </el-date-picker>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20"  :gutter="20">
      <el-col :span="24">
        <el-card><div class="charBox" ref="integrationChar"></div></el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="12">
        <el-card>
          <div class="charBox" ref="TrackingPhase"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/chart/themeRiver')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
// require('echarts/lib/component/visualMap')
export default {
  name: 'finance_analyse',
  props: {
    user: Object
  },
  data () {
    return {

      month: '',
      today_state: {
        create: 0,
        feedback: 0,
        success: 0
      },
      clue_state: {
        total: 0,
        success: 0,
        public: 0
      },
      integrationChar: null,
      TrackingPhaseChart: null,
      IntentionGradeChart: null,
      integrationHeader: ['田嵌', '杨宇璇'],
      integrationCount: [],
      integrationTitle: '财务统计',
      TrackingPhaseTitle: '通知状态',
      IntentionGradeTitle: '意向等级',
      TrackingPhaseHeader: [],
      TrackingPhaseCount: [],
      IntentionGradeHeader: [],
      IntentionGradeCount: []
    }
  },
  watch: {
    integrationCount (val) {
      this.initIntegrationChar()
    },
    TrackingPhaseCount (val) {
      this.initTrackingPhaseChart()
    },
    IntentionGradeCount (val) {
      this.initIntentionGradeChart()
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getData (e) {
      this.integrationCount = [8, 11]
      this.TrackingPhaseCount = [
        {
          name: '未通知',
          value: 8
        },
        {
          name: '已通知',
          value: 4
        },
        {
          name: '确认通过',
          value: 3
        },
        {
          name: '反馈中',
          value: 4
        },
        {
          name: '完成服务',
          value: 2
        }
      ]
    },
    getAnalysisData (type) {
      this.$axios.get('/api/tenant/clue_stat')
        .then((res) => {
          const { data } = res
          console.log(data)
          this.today_state = data.today_state
          this.clue_state = data.clue_state
          this.integrationHeader = data.source_pillar.title
          this.integrationCount = data.source_pillar.values
          this.TrackingPhaseCount = data.schedule_cake
          this.IntentionGradeCount = data.intention_cake
          // this.setActiveCard(1)
        })
    },
    pickerDataChangeUpload (val) {
      if (val) {
        this.month = val
      } else {
        this.month = ''
      }
    },
    // 线索来源
    initIntegrationChar () {
      this.integrationChar = echarts.init(this.$refs.integrationChar, 'light')
      this.setIntegration()
    },
    // 通知状态
    initTrackingPhaseChart () {
      this.TrackingPhaseChart = echarts.init(this.$refs.TrackingPhase, 'light')
      this.setTrackingPhaseChartType()
    },
    // 意向等级
    initIntentionGradeChart () {
      this.IntentionGradeChart = echarts.init(this.$refs.IntentionGrade, 'light')
      this.setIntentionGradeChartType()
    },
    // 跟踪阶段图表
    setTrackingPhaseChartType () {
      let option = {
        title: {
          text: this.TrackingPhaseTitle,
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 'right'
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            data: this.TrackingPhaseCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.TrackingPhaseChart.setOption(option)
    },
    // 意向等级图表
    setIntentionGradeChartType () {
      let option = {
        title: {
          text: this.IntentionGradeTitle,
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 'right'
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            data: this.IntentionGradeCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.IntentionGradeChart.setOption(option)
    },
    // 线索来源
    setIntegration () {
      let option = {
        title: {
          text: this.integrationTitle
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: this.integrationHeader
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.integrationHeader
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.integrationCount,
            type: 'bar',
            barWidth: 15,
            itemStyle: {
              normal: {
                // 这里是重点
                color: function (params) {
                  // 注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                  var colorList = ['#c23531', '#5787ff', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622']
                  return colorList[params.dataIndex % colorList.length]
                }
              }
            }
          }
        ]
      }
      // color:function(params){
      //   var colorList = ['#c23531','#2f4554', '#61a0a8', '#d48265', '#91c7ae','#749f83', '#ca8622'];
      //   return colorList[params.dataIndex % colorList.length];
      // }
      this.integrationChar.setOption(option)
    }
  },
  mounted () {
    // this.getAnalysisData()
    this.getData()
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.clearfix:before,
.clearfix:after
.text-r
  text-align: right
.analyse
  marginLeft()
  .mb20
    margin-bottom: .4rem
  .charBox
    width: 100%
    height: 6rem
  .cardBox
    height: 2rem
    cursor: pointer
  .cardBoxDiv
    height: 100%
  .cardBoxName
    font-size: .4rem
    font-weight: 400
    line-height: .6rem
  .activeBg
    background-color: #5787FF !important
  .activeBg2
    background-color: #FFC68E !important
  .activeBg3
    background-color: #AEA1FB !important
  .cardColor
    color: #A2A2A2
  .activeCardColor
    color: #FFFFFF
</style>



// WEBPACK FOOTER //
// src/pages/finance_analyse/FinanceAnalyse.vue